import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
const GameResultSuccessfullySaved = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content game-result-successfully-saved', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('game_result_successfully_saved'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                        navigate(APP_ROUTES.rallies);
                    } }) })] }));
};
export default GameResultSuccessfullySaved;
